import { css } from 'styled-components'

export default css`
  .add-to-calendar::part(atcb-button) {
    background-color: transparent;
    box-shadow: none;
    border: none;
    width: 240px;
  }

  .add-to-calendar::part(atcb-button-text) {
    color: #ffffff;
    font-family: inherit;
    font-size: 14px;
  }
`
